<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12 v-if="!transactions.length">
      <empty-alert :icon="'sync'" :color="'orange accent-4'" v-if="!transactions.length">
        <div slot="content">
          <p><strong>Nenhuma transação encontrada.</strong></p>
        </div>
      </empty-alert>
    </v-flex>

    <v-flex xs12 v-if="transactions.length">
      <v-layout class="section-header my-3 mx-2" row wrap align-content-center justify-center>
        <v-flex xs12 lg4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-sync</v-icon>
              Últimas transações
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg8>
          <v-layout row wrap justify-end>
            <v-text-field v-model="search" class="search-input" label="Buscar"
              append-icon="fal fa-search"></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 v-if="transactions.length">
      <v-data-table
        class="section-box"
        width="100%"
        :headers="headers"
        :items="transactions"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            <strong>
              {{ props.item.collector.first_name + ' ' + props.item.collector.last_name }}
            </strong>
            (ID: {{ props.item.id }})
          </td>
          <td>
            {{ props.item.transaction_amount | formatCurrency }}
            ({{ props.item.transaction_details.net_received_amount | formatCurrency }})
          </td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.date_created | moment('from', 'now') }}</td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="black" outline>
            Nenhuma transação encontrada.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhuma transação encontrada.
          </div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  props: ['userMP'],

  data: () => ({
    headers: [
      { text: 'Aluno', value: 'collector.first_name' },
      { text: 'Valor', value: 'transaction_amount', width: '300' },
      { text: 'Status', value: 'status', width: '100' },
      { text: 'Data', value: 'date_created', width: '200' }
    ],
    search: '',
    transactions: []
  }),

  methods: {
    loadTransactions () {
      if (!this.userMP || !this.userMP.id) return false
      const path = `${API.mpPayments}/search?payer.email=${this.userMP.email}`
      axios.get(path).then(response => {
        this.transactions = this.transactions.concat(response.data.results)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadUserTransactions')
  },

  created () {
    this.loadTransactions()
    EventBus.$on('loadUserTransactions', this.loadTransactions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowFinancialTransactions.vue